import globalConfig from '../../utiles/globalConfig';
import diffType from './_type';

const forwardLinksParam = sessionStorage.getItem('forwardLinksParam') || ''; // 是否从储值页返回

let gameId =
  globalConfig.getHrefParamUndecode('gameId', forwardLinksParam) ||
  globalConfig.getHrefParam('gameId') ||
  globalConfig.getHrefParamUndecode('gameId') ||
  '';

const page = {
  selectGamePage: gameId ? '' : 'select-pay-game-page',
  selectProductPage: 'select-product-page',
};

export default {
  event: {
    'j-select-game': [
      {
        type: 'click',
        event: 'click-update-game',
        pageName: page.selectGamePage,
      },
    ],
    'j-select-lang-ele': [
      {
        type: 'change',
        event: 'click-update-lang',
      },
      {
        type: 'focus',
        event: 'click-open-lang-list-btn',
      },
    ],
    'j-select-server-ele': [
      {
        type: 'change',
        event: 'click-update-server',
        pageName: page.selectProductPage,
      },
      {
        type: 'focus',
        event: 'click-open-server-list-btn',
        pageName: page.selectProductPage,
      },
    ],
    'j-select-order': [
      {
        type: 'change',
        event: 'click-update-order',
        pageName: page.selectProductPage,
      },
      {
        type: 'focus',
        event: 'click-open-order-list-btn',
        pageName: page.selectProductPage,
      },
    ],
    'j-select-product-type': [
      {
        type: 'click',
        event: 'click-update-product-type',
        pageName: page.selectProductPage,
      },
    ],

    'j-select-role-ele': [
      {
        type: 'change',
        event: 'click-update-role',
        pageName: page.selectProductPage,
      },
      {
        type: 'focus',
        event: 'click-open-role-list-btn',
        pageName: page.selectProductPage,
      },
    ],
    'j-back-game-list': [
      {
        type: 'click',
        event: 'click-back-game-list-btn',
        pageName: page.selectProductPage,
      },
    ],
    'j-select-product': [
      {
        type: 'click',
        event: 'click-update-product',
        newPage: true,
        pageName: page.selectProductPage,
      },
    ],
    'j-service-float-btn': [
      {
        type: 'click',
        event: 'click-service-float-btn',
        newPage: true,
        pageName: page.selectProductPage,
      },
    ],
    'j-again-role': [
      {
        type: 'click',
        event: 'click-again-role-btn',
        pageName: page.selectProductPage,
      },
    ],
    'j-reselect-role': [
      {
        type: 'click',
        event: 'click-reselect-role-btn',
        pageName: page.selectProductPage,
      },
    ],
    'j-logout': [{ type: 'click', event: 'click-logout-product' }],
    productList: [
      {
        type: 'click',
        event: 'show-product-list',
        pageName: page.selectProductPage,
      },
    ],
  },
  enter: {
    selectGamePage: { event: page.selectGamePage },
    showSelectGame: { event: page.selectProductPage },
  },
  observer: {
    showSelectGame: {
      pre: true,
      now: false,
      action: 'enter',
      type: 'computed',
      page: 'webStorePage',
      diffType: diffType.equal,
    },
    productList: {
      action: 'event',
      type: 'computed',
      page: 'webSelectProduct',
      diffType: diffType.noEmptyArrayPre,
    },
  },
};
